import styled from 'styled-components';

export const StyledSteps = styled.ol`
  list-style: none;
  list-style-type: none !important;
  padding-left: 0;

  justify-content: flex-start;
  display: flex;
`;
